import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';

import { App } from './app/App';
import store from './app/store';
import { clientEnvVars } from './common/environment/clientEnvVars';
import { getTheme } from './common/theme';
import './log';
import './polyfills';
import './styles/globals.scss';

const theme = getTheme();

const GlobalCss = () => (
  <GlobalStyles
    styles={{
      // Fix vertival centering of text inside buttons.
      // https://github.com/mui-org/material-ui/issues/13926
      // suggests that this may be due to the font.
      '.MuiButton-label': {
        transform: 'translateY(0.1em)',
      },
      '.MuiLink-underlineHover:hover': {
        textDecoration: 'none',
        cursor: 'pointer',
        opacity: 0.7,
      },
    }}
  />
);

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to={clientEnvVars().NORA_SUBDIR + '/'} replace={true} />,
  },
  {
    path: `/${clientEnvVars().NORA_SUBDIR}/*`,
    element: <App />,
  },
]);

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalCss />
        <RouterProvider router={router} />
      </ThemeProvider>
    </Provider>,
    document.getElementById('nora'),
  );
};

render();

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./app/App', () => {
    render();
  });
}
